import { config } from "../utils/api-utils";
import createAxiosClient from "../utils/api-utils";

class ProfileApi {
  constructor() {
    this.client = createAxiosClient();
  }

  // Load master data from local JSON files under public/master-data
  async listProfile() {
    const base = "/master-data";
    const [religionsJson, castesJson, languagesJson, statesJson, citiesJson, heightsJson, occupationsJson, incomesJson, dietsJson, familyStatusJson, bloodGroupsJson, bodyTypesJson, maritalStatusJson, qualificationsJson, professionTypesJson, healthInfoJson, disabilitiesJson] = await Promise.all([
      fetch(`${base}/religions.json`).then(r => r.json()),
      fetch(`${base}/castes.json`).then(r => r.json()),
      fetch(`${base}/languages.json`).then(r => r.json()),
      fetch(`${base}/states.json`).then(r => r.json()),
      fetch(`${base}/cities.json`).then(r => r.json()),
      fetch(`${base}/heights.json`).then(r => r.json()),
      fetch(`${base}/occupations.json`).then(r => r.json()),
      fetch(`${base}/incomes.json`).then(r => r.json()),
      fetch(`${base}/diets.json`).then(r => r.json()),
      fetch(`${base}/family-status.json`).then(r => r.json()),
      fetch(`${base}/blood-groups.json`).then(r => r.json()),
      fetch(`${base}/body-types.json`).then(r => r.json()),
      fetch(`${base}/marital-status.json`).then(r => r.json()),
      fetch(`${base}/qualifications.json`).then(r => r.json()),
      fetch(`${base}/profession-types.json`).then(r => r.json()),
      fetch(`${base}/health-info.json`).then(r => r.json()),
      fetch(`${base}/disabilities.json`).then(r => r.json()),
    ]);

    // helper mappers
    const toOption = (i) => ({ sid: i.id, name: i.label || i.value || String(i.id), ...i });

    const religions = (religionsJson || []).map(r => ({ ...toOption(r), castes: [] }));
    const castes = (castesJson || []).map(c => toOption(c));
    // attach castes to religions
    religions.forEach(r => {
      r.castes = castes.filter(c => Number(c.religionId) === Number(r.sid));
    });

    const states = (statesJson || []).map(s => ({ ...toOption(s), cities: [] }));
    const cities = (citiesJson || []).map(c => toOption(c));
    states.forEach(s => {
      s.cities = cities.filter(c => Number(c.stateId) === Number(s.sid));
    });

    const profile = {
      religions,
      castes,
      gothra: castes, // fallback
      motherTongues: (languagesJson || []).map(toOption),
      states,
      cities,
      heights: (heightsJson || []).map(toOption),
      qualifications: (qualificationsJson || []).map(toOption),
      professions: (occupationsJson || []).map(toOption),
      professionTypes: (professionTypesJson || []).map(toOption),
      incomes: (incomesJson || []).map(toOption),
      diets: (dietsJson || []).map(toOption),
      healthInfo: (healthInfoJson || []).map(toOption),
      disabilities: (disabilitiesJson || []).map(toOption),
      familyStatuses: (familyStatusJson || []).map(toOption),
      familyValues: (familyStatusJson || []).map(toOption),
      bloodGroups: (bloodGroupsJson || []).map(toOption),
      bodyTypes: (bodyTypesJson || []).map(toOption),
      maritalStatuses: (maritalStatusJson || []).map(toOption),
      // keep raw files available for any custom needs
      _raw: {
        religionsJson,
        castesJson,
        languagesJson,
        statesJson,
        citiesJson,
        heightsJson,
        occupationsJson,
        incomesJson,
        dietsJson,
        familyStatusJson,
        bloodGroupsJson,
        bodyTypesJson,
        maritalStatusJson
      }
    };

    return { data: profile };
  }

  async getProfilebyId(id) {
    return this.client.get(`/profile/${id}`, config());
  }

  async unlockPhone(profileId) {
    return this.client.post(`/profiles/${profileId}/unlock-phone`, {}, config());
  }

  async deactivateProfile(data) {
    return this.client.post('/users/me/deactivate', data, config());
  }
}

export default ProfileApi = new ProfileApi();
